package com.veldekar.components.srd.spells

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun ScryingDescription() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("You can see and hear a particular creature you choose that is on the same plane of existence as you. The target must make a wisdom saving throw, which is modified by how well you know the target and the sort of physical connection you have to it. If a target knows you're casting this spell, it can fail the saving throw voluntarily if it wants to be observed.")
    }
    org.jetbrains.compose.web.dom.Table {
        org.jetbrains.compose.web.dom.Thead {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Knowledge")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Save Modifier")
                }
            }
        }
        org.jetbrains.compose.web.dom.Tbody {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Secondhand (you have heard of the target)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("+5")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Firsthand (you have met the target)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("+0")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Familiar (you know the target well)")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("-5")
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.Table {
        org.jetbrains.compose.web.dom.Thead {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Connection")
                }
                org.jetbrains.compose.web.dom.Th {
                    org.jetbrains.compose.web.dom.Text("Save Modifier")
                }
            }
        }
        org.jetbrains.compose.web.dom.Tbody {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Likeness or picture")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("-2")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Possession or garment")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("-4")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("Body part, lock of hair, bit of nail, or the like")
                }
                org.jetbrains.compose.web.dom.Td {
                    org.jetbrains.compose.web.dom.Text("-10")
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("On a successful save, the target isn't affected, and you can't use this spell against it again for 24 hours.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("On a failed save, the spell creates an invisible sensor within 10 feet of the target. You can see and hear through the sensor as if you were there. The sensor moves with the target, remaining within 10 feet of it for the duration. A creature that can see invisible objects sees the sensor as a luminous orb about the size of your fist.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Instead of targeting a creature, you can choose a location you have seen before as the target of this spell. When you do, the sensor appears at that location and doesn't move.")
    }
}
